/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Defaulttitle1Inputs */

const id_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const ms_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const da_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg`)
};

const de_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche`)
};

const en_us2_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const es_es2_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const es_mx2_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const fil_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap`)
};

const fr_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche`)
};

const it_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const hu_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés`)
};

const nl_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken`)
};

const no_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk`)
};

const pl_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj`)
};

const pt_br2_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar`)
};

const pt_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar`)
};

const ro_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Căutare`)
};

const fi_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haku`)
};

const sv_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök`)
};

const vi_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm`)
};

const tr_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ara`)
};

const cs_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat`)
};

const bg_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене`)
};

const ru_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск`)
};

const uk_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук`)
};

const ar_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث`)
};

const hi_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज`)
};

const th_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหา`)
};

const ja_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索`)
};

const zh_cn2_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

const zh_hant1_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋`)
};

const ko_search_defaulttitle1 = /** @type {(inputs: Search_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Search_Defaulttitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_defaulttitle1 = /** @type {((inputs?: Search_Defaulttitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Defaulttitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_defaulttitle1(inputs)
	if (locale === "ms") return ms_search_defaulttitle1(inputs)
	if (locale === "da") return da_search_defaulttitle1(inputs)
	if (locale === "de") return de_search_defaulttitle1(inputs)
	if (locale === "en-US") return en_us2_search_defaulttitle1(inputs)
	if (locale === "es-ES") return es_es2_search_defaulttitle1(inputs)
	if (locale === "es-MX") return es_mx2_search_defaulttitle1(inputs)
	if (locale === "fil") return fil_search_defaulttitle1(inputs)
	if (locale === "fr") return fr_search_defaulttitle1(inputs)
	if (locale === "it") return it_search_defaulttitle1(inputs)
	if (locale === "hu") return hu_search_defaulttitle1(inputs)
	if (locale === "nl") return nl_search_defaulttitle1(inputs)
	if (locale === "no") return no_search_defaulttitle1(inputs)
	if (locale === "pl") return pl_search_defaulttitle1(inputs)
	if (locale === "pt-BR") return pt_br2_search_defaulttitle1(inputs)
	if (locale === "pt") return pt_search_defaulttitle1(inputs)
	if (locale === "ro") return ro_search_defaulttitle1(inputs)
	if (locale === "fi") return fi_search_defaulttitle1(inputs)
	if (locale === "sv") return sv_search_defaulttitle1(inputs)
	if (locale === "vi") return vi_search_defaulttitle1(inputs)
	if (locale === "tr") return tr_search_defaulttitle1(inputs)
	if (locale === "cs") return cs_search_defaulttitle1(inputs)
	if (locale === "bg") return bg_search_defaulttitle1(inputs)
	if (locale === "ru") return ru_search_defaulttitle1(inputs)
	if (locale === "uk") return uk_search_defaulttitle1(inputs)
	if (locale === "ar") return ar_search_defaulttitle1(inputs)
	if (locale === "hi") return hi_search_defaulttitle1(inputs)
	if (locale === "th") return th_search_defaulttitle1(inputs)
	if (locale === "ja") return ja_search_defaulttitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_defaulttitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_defaulttitle1(inputs)
	return ko_search_defaulttitle1(inputs)
});
export { search_defaulttitle1 as "search.defaultTitle" }